interface FinanceStaleNoticeProps {
  staleMinutes: number;
  onRefresh: () => void;
}

export default function FinanceStaleNotice({ staleMinutes, onRefresh }: FinanceStaleNoticeProps) {
  return (
    <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-amber-50 border border-amber-200/60">
      <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
        <i className="ri-time-line text-amber-500 text-xs" />
      </span>
      <p className="text-[11px] text-amber-700 leading-snug flex-1">
        财经热点已 {staleMinutes} 分钟未更新，内容可能已过期
      </p>
      <button
        onClick={onRefresh}
        className="text-[11px] font-medium text-amber-700 hover:text-amber-800 px-2 py-1 rounded-md hover:bg-amber-100 transition-colors cursor-pointer whitespace-nowrap flex-shrink-0"
      >
        立即更新
      </button>
    </div>
  );
}